import { useTranslations } from "src/apps/hooks/useTranslations";
import { ChevronIcon } from "src/apps/components/chevronIcon/ChevronIcon";
import styled from "styled-components";
import { colors } from "@permisso/permisso-components";

interface OrderBoxToggleButtonProps {
  isFileListExpanded: boolean;
  missingResponsesCount: number;
  handleToggle: () => void;
}

export const OrderBoxToggleButton = ({
  isFileListExpanded,
  missingResponsesCount,
  handleToggle,
}: OrderBoxToggleButtonProps) => {
  const { t } = useTranslations();

  return (
    <ToggleButton type="button" onClick={handleToggle}>
      {isFileListExpanded
        ? t("documentation_area.show_less")
        : t("documentation_area.show_more", {
            number: missingResponsesCount.toString(),
          })}
      <ChevronIcon rotated={isFileListExpanded} color={colors.grey700} />
    </ToggleButton>
  );
};

const ToggleButton = styled.button`
  display: flex;
  flex-direction: row;
  padding: 0;
  gap: 0.25rem;
  align-items: center;
  align-self: center;
  cursor: pointer;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  color: ${colors.grey700};
`;
